// import NewCompany from '@/views/register/NewCompany'
// import NewCompanyRegister from '@/views/signUp/NewCompany.vue';
// import Company from '@/views/company/Company'
// import Logout from '@/views/logout/Logout'
// import PrivacyPolicy from '@/views/policies/PrivacyPolicy'
// import TermsOfUse from '@/views/policies/TermsOfUse'
// import AlertMobile from '@/views/mobile/AlertMobile'
const NewCompany = () => import('@/views/register/NewCompany');
const NewCompanyRegister = () => import('@/views/signUp/NewCompany.vue');
const Company = () => import('@/views/company/Company');
const Logout = () => import('@/views/logout/Logout');
const PrivacyPolicy = () => import('@/views/policies/PrivacyPolicy');
const TermsOfUse = () => import('@/views/policies/TermsOfUse');
const AlertMobile = () => import('@/views/mobile/AlertMobile');

import getWhiteLabel from '@/utils/getWhiteLabel';


const mobileAlert = {
    path: '/mobile',
    component: AlertMobile,
    name: 'mobile',
    meta: {
        title: `${getWhiteLabel()} - Versão mobile`,
        requiresAuth: false
    },
}

const newCompany = {
    path: '/company/new/:type',
    component: NewCompany,
    name: 'company/new',
    meta: {
        title: `${getWhiteLabel()} - Nova Empresa`,
        requiresAuth: true
    },
}

const newGroupCompany = {
    path: '/group/:groupId/company/new/:type',
    component: NewCompany,
    name: 'company/new',
    meta: {
        title: `${getWhiteLabel()} - Nova Empresa`,
        requiresAuth: true
    },
}

const newSponsorPartner = {
    path: '/partner/:partnerId/company/new/:type',
    component: NewCompany,
    name: 'company/new',
    meta: {
        title: `${getWhiteLabel()} - Nova Empresa`,
        requiresAuth: true
    },
}

const privacyPolicy = {
    path: '/politica',
    component: PrivacyPolicy,
    name: 'company/new',
    meta: {
        title: `${getWhiteLabel()} - Politica de Privacidade`,
        requiresAuth: false
    },
}

const newCompanyRegister = {
    path: '/company/register/new',
    component: NewCompanyRegister,
    name: 'company/new',
    meta: {
        title: `${getWhiteLabel()} - Nova Empresa`,
        requiresAuth: true
    },
}

const selectCompany = {
    path: '/company/select',
    component: Company,
    name: 'company/select',
    meta: {
        title: `${getWhiteLabel()} - Selecionar empresa`,
        requiresAuth: true
    },

}

const logout = {
    path: '/logout',
    component: Logout,
    name: 'logout',
    meta: {
        requiresAuth: false
    },

}

const termsOfUse = {
    path: '/termos',
    component: TermsOfUse,
    name: 'company/new',
    meta: {
        title: `${getWhiteLabel()} - Termos de uso`,
        requiresAuth: false
    },
}

export {
    mobileAlert,
    privacyPolicy,
    newCompanyRegister,
    selectCompany,
    newCompany,
    logout,
    termsOfUse,
    newGroupCompany,
    newSponsorPartner,
};